import React, {Fragment} from 'react';
import {SucessSubscriptionDialog} from 'presentation/components/SucessSubscriptionDialog';
import {ModalError} from 'presentation/components/ModalError';
import {translations} from 'presentation/translations-new';
import {OperationStateTypesEnum} from 'presentation/constants';
import {ConfirmSubscriptionDialog} from 'presentation/pages/private/home/components/ConfirmSubscriptionDialog';
import {InfoSubscriptionDialog} from 'presentation/components/InfoSubscriptionDialog';
import {useNewBillsBemobiFeatureFlag} from 'presentation/pages/private/hooks/useNewBillsBemobiFeatureFlag';
import {SubscriptionDialogsProps} from './types';
import {ModalCompleteYourProfile} from '../ModalCompleteYourProfile';
import {useSubscriptionDialogsStateStore} from './store/useSubscriptionDialogsStateStore';

const {notice, unableToContinue, errorModalDescription, tryAgain} = translations['pt-br'].commons;

export function SubscriptionDialogs({
	isSubmitting,
	onSubscriptionResponse,
	onCloseSubscriptionModal,
	onCloseSubscriptionSucessModal,
	onShowSubscriptionModal,
	onCloseInfoModal,
	onShowInfoModal,
	currentEmail,
	protocol,
	setOperationState,
	isBemobiFlow: isBemobiFlowProp,
	dataTagId,
}: SubscriptionDialogsProps) {
	const dialogs = useSubscriptionDialogsStateStore(state => state.state);
	const {isEnabled: isBemobiFlagEnabled} = useNewBillsBemobiFeatureFlag();
	const isBemobiFlow = isBemobiFlowProp ?? isBemobiFlagEnabled;

	return (
		<Fragment>
			{dialogs.isSubscriptionModalOpen ? (
				<Fragment>
					<ConfirmSubscriptionDialog
						isBemobiFlow={isBemobiFlow}
						onCloseModal={onCloseSubscriptionModal}
						disabled={isSubmitting}
						onPrimaryAction={() => {
							onSubscriptionResponse();
							setOperationState(OperationStateTypesEnum.SUBMITTING);
						}}
						onSecondaryAction={onCloseSubscriptionModal}
						open={dialogs.isSubscriptionModalOpen}
						setOpen={onShowSubscriptionModal}
						email={currentEmail}
					/>
					<ModalCompleteYourProfile />
				</Fragment>
			) : null}
			{dialogs.isSubscriptionSucessModalOpen ? (
				<SucessSubscriptionDialog
					isBemobiFlow={isBemobiFlow}
					dataTagId={dataTagId}
					email={currentEmail}
					open={dialogs.isSubscriptionSucessModalOpen}
					onBack={onCloseSubscriptionSucessModal}
					protocolValue={protocol || ''}
				/>
			) : null}
			{dialogs.isSubscriptionErrorModalOpen ? (
				<ModalError
					headerTitle={notice}
					title={unableToContinue}
					description={errorModalDescription}
					open={dialogs.isSubscriptionErrorModalOpen}
					maxWidth={420}
					isFullScreen={false}
					disableClose={true}
					firstButton={{
						title: tryAgain,
						handleClick: () => {
							onSubscriptionResponse();
							setOperationState(OperationStateTypesEnum.SUBMITTING);
						},
					}}
					disabled={isSubmitting}
				/>
			) : null}
			{dialogs.isSubscriptionInfoModalOpen ? (
				<InfoSubscriptionDialog
					isBemobiFlow={isBemobiFlow}
					onClose={onCloseInfoModal}
					open={dialogs.isSubscriptionInfoModalOpen}
					email={currentEmail}
					onPrimaryAction={onCloseInfoModal}
					setOpen={onShowInfoModal}
				/>
			) : null}
		</Fragment>
	);
}
